package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("business_travel")
@Composable
fun BusinessTravelPage() {
    BlogLayout(
        PageProperties(
            "Business",
            ""
        ),
        BlogProperties("Business", "Travel Space")
    ) {
        Column(
            horizontalAlignment = Alignment.Start,
        ) {
            SpanText(
                text = "Travel Space Bit For Exploration",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When I travel for business, I always make space for a bit of exploration.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Not because I have extra time — I rarely do — but because I believe that travel itself fuels my work.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "I’ve never seen business trips as something purely transactional. For me, every city visit is an opportunity to see how people live, what they eat, how they connect, and how they build things. That’s where real inspiration comes from.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When I’m in a new place, I take time beyond meetings and conference halls — walking through markets, talking to locals, tasting the food, observing daily life. Each city has its own rhythm, and that rhythm often gives me ideas I’d never find in front of a laptop.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sometimes product ideas appear in a small café. Sometimes clarity about a strategic decision comes while walking. Travel keeps my thinking sharp, flexible, and human.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Yes, the schedule can be full — but balance isn’t something you stumble upon; it’s something you intentionally create.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Even one quiet evening walk can reset your energy and perspective. In the end, travel isn’t a break from business — it’s a part of what makes it meaningful.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}
